import React from 'react';
import { logActivity } from './services/activityLogService';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    logActivity('fatal', 'error', 'RENDER_ERROR', error?.message || 'React render error', {
      stack: error?.stack,
      componentStack: info?.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{padding: 40, textAlign: 'center'}}>
          <h2>Something went wrong.</h2>
          <p>We're working to fix it. Please try again later.</p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
